import React, {useContext, useEffect, useRef, useState} from "react"
import DiscountCodeContext, {DiscountCodeType} from "../context/DiscountCodeContext"
import FirebaseContext from "../context/FirebaseContext"
import OrganizationContext from "../context/OrganizationContext"

type Props = {
    children: React.ReactNode
}
function DiscountCodeContextProvider({children}:Props) {
	const [discountCode, setDiscountCode] = useState<DiscountCodeType>({
		code: "",
		discountAmount: 0,
		isOrganizationDiscount: false,
		isMandatoryForCheckout: null,
		notApplicable: false
	})

	const {user} = useContext(FirebaseContext)
	const uid = user?.uid
	const {organizationData, organizationSlug} = useContext(OrganizationContext)
	useEffect(() => {
		if (organizationSlug) {
			setDiscountCode(prevData => ({...prevData, isMandatoryForCheckout: organizationData?.discountCodeIsRequiredForCheckout}))
		}
	}, [organizationData?.discountCodeIsRequiredForCheckout])

	return (
		<DiscountCodeContext.Provider value={{discountCode, setDiscountCode, uid}}>
			{children}
		</DiscountCodeContext.Provider>
	)
}

export default DiscountCodeContextProvider
